'use client';

import { Label } from '@/shared/components/ui/label';
import { Slider } from '@/shared/components/ui/slider';
import { InputProps } from '@/types/form/input-props';
import { InputErrors } from './input-errors';

export function SliderInput({ value, onChange, label, errors, max, min, step }: InputProps<number>) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <Label className="leading-6">{label}</Label>
        <output className="text-sm font-medium tabular-nums">{value}</output>
      </div>
      <Slider
        value={[value]}
        max={Number(max)}
        min={Number(min)}
        step={Number(step)}
        onValueChange={([value]) => onChange(value)}
        aria-label="Slider with output"
        className="**:data-[slot=slider-thumb]:shadow-none [&>:last-child>span]:h-6 [&>:last-child>span]:w-2.5 [&>:last-child>span]:border-[3px] [&>:last-child>span]:border-background [&>:last-child>span]:bg-primary [&>:last-child>span]:ring-offset-0"
      />
      <InputErrors errors={errors} />
    </div>
  );
}
